import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import arrowUp from "../assets/arrow-up.svg";
const ButtonUp = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.scrollY;
    setScrollPosition(position);
  };
  const goUp = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Button
      onClick={() => goUp()}
      animate={{ y: 0 }}
      initial={{ y: 200 }}
      transition={{ type: "spring", duration: 1 }}
      style={{ display: scrollPosition <= 100 ? "none" : "block" }}
    >
      <img src={arrowUp} alt="" />
    </Button>
  );
};

export default ButtonUp;
const Button = styled(motion.button)`
  height: 2.5rem;
  width: 2.5rem;
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  background: #fefefe;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  img {
    widht: 100%;
    height: 100%;
  }
`;
